import { JOURNEY_LIBRARY_BY_ID } from '../data/journeyLibrary.js';
import { resolveTrustQrValue } from './qrConfiguration.js';

export function isTemplateJourneyPath(pathname) {
  const match = String(pathname || '').match(/^\/journeys\/([^/]+)\/?$/);
  return Boolean(match && JOURNEY_LIBRARY_BY_ID[match[1]]);
}

// A plain template link identifies Generic NHS, independently of browser history.
// Private /j/ links and dedicated Easy Read/review routes keep their own rules.
export function templateJourneyTrust(pathname, search = '') {
  if (!isTemplateJourneyPath(pathname)) return null;
  return resolveTrustQrValue(new URLSearchParams(search).get('trust')) || 'generic_nhs';
}

export function withJourneyTrust(href, trustId) {
  const url = new URL(href, 'https://knowyourcare.co.uk');
  if (!isTemplateJourneyPath(url.pathname)) return href;
  url.searchParams.set('trust', trustId || 'generic_nhs');
  return url.pathname + url.search + url.hash;
}
